export const defaultPassword = '000000'
export const defaultRechargeLimit = 2000
export const defaultRechargeLowerLimit = 100
export const maxMoney = 9999
export const maxRechargeMoney = 999999

export const ossTokenApiPath = '/resource/upload/token'

export const resourceApiPath = '/resource'

export const imageAccept = 'image/jpeg,image/jpg,image/png,image/gif'
export const groupTicketLength = 15
export const productOrderLength = 9

// 是否显示未开发完成的功能，通过 env 配置，默认为 true，生产环境为 false
export const showUnfinishedFeature
  = (import.meta.env.VITE_SHOW_UNFINISHED_FEATURE === 'true')
    || new URL(window.location.href).searchParams.get('show_feature') === '1'

// 是否显示虚拟打印结果，通过 env 配置，默认为 true，生产环境为 false
export const showVirtualPrintResult: boolean = import.meta.env.VITE_SHOW_VIRTUAL_PRINT_RESULT === 'true'

// 是否显示模拟读卡器，通过 env 配置，默认为 true，生产环境为 false
export const showFakeCardReader: boolean = import.meta.env.VITE_SHOW_FAKE_CARD_READER === 'true'
